import { render, staticRenderFns } from "./IndividualTeacher.vue?vue&type=template&id=698f42d1"
import script from "./IndividualTeacher.vue?vue&type=script&lang=js"
export * from "./IndividualTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports